export default {"src":"/_next/static/media/blokc.56cc0049.svg","height":673,"width":674,"blurWidth":0,"blurHeight":0};